import colors from './colors';

const semanticTokens = {
  colors: {
    'bg.canvas':             { default: colors.background.light,            _dark: colors.background.dark },
    'bg.canvas.translucent': { default: colors.background.translucentLight, _dark: colors.background.translucentDark },
    'bg.surface':            { default: colors.surface.light,               _dark: colors.surface.dark },
    'bg.surface.translucent': { default: colors.surface.translucentLight,   _dark: colors.surface.translucentDark },
    // Faint wash used for idle affordances (black-on-light, white-on-dark)
    'bg.subtleTint':         { default: `rgba(${colors.neutral.rgb.black}, 0.04)`, _dark: `rgba(${colors.neutral.rgb.white}, 0.05)` },

    'text.primary':          { default: colors.text.primary.light,          _dark: colors.text.primary.dark },
    'text.muted':            { default: colors.text.secondary.light,        _dark: colors.text.secondary.dark },
    'text.onBrand':          { default: colors.neutral.cream,               _dark: colors.neutral.cream },

    'border.subtle':         { default: colors.border.light,                _dark: colors.border.dark },
    'border.accent':         { default: colors.border.hover,                _dark: colors.border.hover },

    'brand.primary':         { default: colors.brand.primary.light,         _dark: colors.brand.primary.dark },
    'brand.primary.shade':   { default: colors.brand.primary.shade,         _dark: colors.brand.primary.shade },
    'brand.secondary':       { default: colors.brand.secondary.light,       _dark: colors.brand.secondary.dark },
    'brand.success':         { default: colors.brand.success.light,         _dark: colors.brand.success.dark },

    // RGB triplets for composing rgba() at arbitrary alpha:
    //   background: `rgba(var(--chakra-colors-brand-primary-rgb), 0.3)`
    'brand.primary.rgb':     { default: colors.brand.primary.rgb.light,     _dark: colors.brand.primary.rgb.dark },
    'brand.secondary.rgb':   { default: colors.brand.secondary.rgb.light,   _dark: colors.brand.secondary.rgb.dark },
  },
};

export default semanticTokens;
